module.exports = __webpack_public_path__ + "nnone-state-icon.svg";